import React, { useState, useEffect, useRef } from "react";

export default function Timer({ endDate, onEnd }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isEnded, setIsEnded] = useState(false);
  const hasEndedRef = useRef(false);

  useEffect(() => {
    console.log("endDate", endDate);
    if (!endDate) return;

    // Check if already ended initially
    const now = new Date();
    if (endDate <= now && !hasEndedRef.current) {
      setIsEnded(true);
      if (onEnd && typeof onEnd === "function") {
        onEnd();
        hasEndedRef.current = true;
      }
    }

    const calculateTimeLeft = () => {
      const difference = endDate - new Date();

      if (difference <= 0) {
        if (!hasEndedRef.current && onEnd && typeof onEnd === "function") {
          onEnd();
          hasEndedRef.current = true;
        }
        setIsEnded(true);
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        };
      }

      return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate, onEnd]);

  if (isEnded) {
    return (
      <div className="text-red-500 font-bold text-lg">
        L'enchère est terminée
      </div>
    );
  }

  return (
    <div className="flex gap-4 justify-center items-center">
      <div className="text-center">
        <div className="text-2xl font-bold">{timeLeft.days}</div>
        <div className="text-sm text-gray-600">jours</div>
      </div>
      <div className="text-center">
        <div className="text-2xl font-bold">{timeLeft.hours}</div>
        <div className="text-sm text-gray-600">heures</div>
      </div>
      <div className="text-center">
        <div className="text-2xl font-bold">{timeLeft.minutes}</div>
        <div className="text-sm text-gray-600">minutes</div>
      </div>
      <div className="text-center">
        <div className="text-2xl font-bold">{timeLeft.seconds}</div>
        <div className="text-sm text-gray-600">secondes</div>
      </div>
    </div>
  );
}
